import * as contractActions from "@rentiohq/shared-frontend/dist/reduxV2/contract/contract.actions";
import * as contractSelectorsV2 from "@rentiohq/shared-frontend/dist/reduxV2/contract/contract.selectors";
import { ERentioMoveMovement } from "@rentiohq/shared-frontend/dist/reduxV2/contract/contract.types";
import { EContractMemberTypes } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { IRootStore } from "redux/reducers";
import {
  EField,
  IExtraData,
} from "./schema.requestRentioMoveServiceExit.types";
import { hasTenants } from "./schema.requestRentioMoveServiceExit.utils";

export const performingSubmitActionResultSelector =
  (contractId: string) => (state: IRootStore) =>
    contractSelectorsV2.isRequestingRentioMoveService(state, contractId);

export const submitActionCreator =
  (extraData: IExtraData) => (formData: any) => {
    const { contract, contacts } = extraData;
    // Always treat as empty property contract in exit flow
    const isVacancyContract = hasTenants(extraData);
    const departingTenantMember = isVacancyContract
      ? extraData.contract?.members?.find((member: any) =>
          member.roles.includes(EContractMemberTypes.Tenant),
        )
      : undefined;
    const departingTenantContact =
      isVacancyContract && departingTenantMember
        ? contacts.find(
            contact => contact.accountId === departingTenantMember?.account?.id,
          )
        : undefined;

    return contractActions.requestRentioMoveServiceStart.getAction({
      id: contract.id,
      data: {
        movement: ERentioMoveMovement.Exit,
        moveDate: formData[EField.MoveDate],
        services: formData[EField.Services],
        residentCount: formData[EField.ResidentCount],
        // For vacancy contracts: vacancy holder becomes newTenantAccountId
        // For regular exit: departing tenant info is provided
        newTenantAccountId: isVacancyContract
          ? formData[EField.VacancyPropertyContractHolder]?.[0]
          : formData[EField.DepartingTenant]?.[0],
        noContract: isVacancyContract,
        // Manual departing tenant info (when no account selected)
        departingTenantFirstName: !isVacancyContract
          ? formData[EField.DepartingTenantFirstName]
          : departingTenantContact?.firstname,
        departingTenantLastName: !isVacancyContract
          ? formData[EField.DepartingTenantLastName]
          : departingTenantContact?.lastname,
        departingTenantEmail: !isVacancyContract
          ? formData[EField.DepartingTenantEmail]
          : departingTenantContact?.email,
      },
    });
  };
